var _path, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferAFriend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 80,
    viewBox: "0 0 125 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.26 74.483H30.4466L72.2621 69.3841C80.565 68.3717 86.4358 60.7639 85.3101 52.4757L82.8249 34.1779C82.4598 31.4902 81.3728 28.9517 79.6796 26.8327L64.452 7.77668C60.6861 3.06391 54.4633 1.06576 48.6577 2.70506L14.5835 12.3264C6.5534 14.5938 1.91716 22.9785 4.2663 30.985L13.8667 63.706C15.7411 70.0945 21.6022 74.483 28.26 74.483Z",
    fill: "#FFEADB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9365 25.0718L58.9717 14.2661L99.6606 2.70663L112.596 48.2383C113.501 51.4259 111.652 54.7441 108.464 55.6496L41.2832 74.7354C38.0956 75.641 34.7774 73.791 33.8719 70.6035L20.9365 25.0718Z",
    fill: "#E62645"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.5752,
    y: 30.4253,
    width: 71.5634,
    height: 48.5749,
    fill: "white",
    stroke: "#4B4A50",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0885 62.2102C87.6806 62.6354 87.0255 62.6354 86.6233 62.2102L80.3662 55.6488C78.5505 53.7413 78.6597 50.5812 80.6879 48.8231C82.4576 47.2891 85.095 47.5648 86.7153 49.2713L87.3531 49.9377L87.9966 49.2655C89.6169 47.5648 92.2542 47.2891 94.0239 48.8231C96.0579 50.5812 96.1613 53.7413 94.3457 55.6488L88.0885 62.2102Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2985 13.8892L20.9365 25.0718L66.1126 40.6294C67.3001 41.0384 68.6166 40.6644 69.4117 39.6922L99.6606 2.70663L60.2985 13.8892Z",
    fill: "#A7163E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferAFriend);
export default __webpack_public_path__ + "static/media/refer-a-friend.5ba4b56a5ae9c41aa53f9a9dea268f18.svg";
export { ForwardRef as ReactComponent };